export function formatDate(timestamp: string): string {
  const date = new Date(timestamp + "Z");
  return date.toLocaleString("en-GB", {
    timeZone: "Europe/Brussels",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}
